import { NextPage } from "next"
import Head from "next/head"
import { DefaultLayout } from "src/components/Layout"
import { UserBankAccountList } from "src/features/user-bank-account/components/UserBankAccountList"

const BankAccountsPage: NextPage = () => (
  <DefaultLayout>
    <Head>
      <title>Bank Accounts | for Smoother</title>
    </Head>
    <div data-smooth-ds className="min-h-screen bg-bg-subtle">
      <div className="mx-auto px-4 py-6">
        <UserBankAccountList />
      </div>
    </div>
  </DefaultLayout>
)

export default BankAccountsPage
